import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationRnecComponent } from './authentication-rnec/authentication-rnec.component';
import { BdbIdentityNumberComponent } from './bdb-identity-number/bdb-identity-number.component';
import { BdbRegulationProductsComponent } from './bdb-regulation-products/bdb-regulation-products.component';
import { BdbRegulationRnecComponent } from './bdb-regulation-rnec/bdb-regulation-rnec.component';
import { BdbValidateOneTimePasswordComponent } from './bdb-one-time-password/validate-otp/bdb-validate-one-time-password.component';
import { BdbExpeditionDateComponent } from './bdb-expedition-date/bdb-expedition-date.component';
import { BdbSecondFactorSelectorComponent } from './bdb-second-factor-selector/bdb-second-factor-selector.component';
import { BdbSecurePasswordComponent } from './bdb-secure-password/bdb-secure-password.component';
import { BdbTokenComponent } from './bdb-token/bdb-token.component';
import { BdbDebitCardPasswordComponent } from './bdb-debit-card-password/bdb-debit-card-password.component';
import { BdbCifinConfrontaComponent } from './bdb-cifin-confronta/bdb-cifin-confronta.component';
import {BdbErrorComponent} from './bdb-error/bdb-error.component';
import { BdbHandlerComponent } from './bdb-handler/bdb-handler.component';
import { AuthenticationRnecV2Component } from './authentication-rnec-v2/authentication-rnec-v2.component';
import { BdbErrorV2Component } from './bdb-error-v2/bdb-error-v2.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';


const routes: Routes = [
    { path: 'identity-number', component: BdbIdentityNumberComponent},
    { path: 'regulation-products', component: BdbRegulationProductsComponent },
    { path: 'expedition-date', component: BdbExpeditionDateComponent },
    { path: 'regulation-rnec', component: BdbRegulationRnecComponent },
    { path: 'rnec', component: AuthenticationRnecComponent },
    { path: 'rnec-v2', component: AuthenticationRnecV2Component },
    { path: 'second-factor-selector', component: BdbSecondFactorSelectorComponent },
    { path: 'debit-card-password', component: BdbDebitCardPasswordComponent },
    { path: 'token', component: BdbTokenComponent },
    { path: 'secure-password', component: BdbSecurePasswordComponent },
    { path: 'cifin-confronta', component: BdbCifinConfrontaComponent },
    { path: 'validate-one-time-password', component: BdbValidateOneTimePasswordComponent },
    { path: 'error', component: BdbErrorComponent},
    { path: 'error-v2', component: BdbErrorV2Component},
    { path: 'error-page', component: ErrorPageComponent},
    { path: '**', component: BdbHandlerComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}




// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts